import safeStringify from "fast-safe-stringify";
import { createLogger } from "./createLogger";
import { getTime } from "./time";
import Constants from "@/constants";
import { HUYASdk } from "@huyafed/huya-kiwi";
import { env } from "@/config/env";

const timestamp = Date.now();

function safetyStringify(v: any) {
  try {
    return safeStringify(v);
  } catch (error) {
    return "";
  }
}

const logger = createLogger({
  onAfter(logInfo) {
    // 写入宿主日志, 宿主环境需要反馈日志，在日志后台查看：
    // https://ffilelogweb2.huya.com/#/feedback?uidType=0&collectStatus=0&logBeginTime=1743321263406&appId=200&isNotAutoFeedback=1&stop=0&queryDistinct=0
    HUYASdk.log(logInfo.desc + " " + safetyStringify(logInfo.data));
  },
  prefix() {
    // 如果 appName 不被编译，手动换上项目名
    return `eldenring-map * date:${getTime()} uid:${env.uid} sessionId:${timestamp} -`;
  },
  enableLog() {
    // production 模式不会在控制台打印日志
    if (Constants.IS_DEBUG || Constants.LOGGER_DEV) return true;
    return false;
  },
});

export default logger;
